import clone from 'lodash/clone'
import isEmpty from 'lodash/isEmpty'
import * as actions from 'actions'

const initialState = {
  profilesListLoading: false,
  paginatedProfilesList: [],
  totalCount: 0,
  hasMoreData: false,
  params: {},
}

export function profileListReducer(state = initialState, action) {
  switch (action.type) {
    case `${actions.PROFILE_MANAGEMENT_GET_PROFILES}_PENDING`: {
      return {
        ...state,
        profilesListLoading: true,
      }
    }

    case `${actions.PROFILE_MANAGEMENT_GET_PROFILES}_FULFILLED`: {
      const { data, count, page } = action.payload.data
      const { params = {} } = action.meta
      let updatedData = []

      if (page === 0) {
        updatedData = data
      } else {
        updatedData = [...state.paginatedProfilesList, ...data]
      }

      return {
        ...state,
        profilesListLoading: false,
        paginatedProfilesList: updatedData,
        hasMoreData: updatedData.length < count,
        totalCount: count,
        params,
      }
    }

    case `${actions.PROFILE_MANAGEMENT_GET_PROFILES}_REJECTED`: {
      return {
        ...state,
        profilesListLoading: false,
      }
    }

    case `${actions.PROFILE_MANAGEMENT_DELETE_PROFILE}_FULFILLED`: {
      const { profileId } = action.meta
      let updatedData = []
      if (!isEmpty(state?.paginatedProfilesList)) {
        updatedData = clone(state.paginatedProfilesList)
        const indexOfProfile = updatedData.findIndex(
          profile => profile.id === profileId
        )
        updatedData.splice(indexOfProfile, 1)
      }

      return {
        ...state,
        paginatedProfilesList: updatedData,
      }
    }

    case `${actions.PROFILE_MANAGEMENT_TOGGLE_PROFILE}_FULFILLED`: {
      const { profileId, status } = action.meta
      let updatedData = []
      if (!isEmpty(state?.paginatedProfilesList)) {
        updatedData = clone(state.paginatedProfilesList)
        const indexOfProfile = updatedData.findIndex(
          profile => profile.id === profileId
        )
        updatedData[indexOfProfile].status = status
      }

      return {
        ...state,
        paginatedProfilesList: updatedData,
      }
    }

    default:
      return { ...state }
  }
}
